import { render } from "./DocumentHeader.vue?vue&type=template&id=54fe8bd8&scoped=true"
import script from "./DocumentHeader.vue?vue&type=script&lang=js"
export * from "./DocumentHeader.vue?vue&type=script&lang=js"

import "./DocumentHeader.vue?vue&type=style&index=0&id=54fe8bd8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54fe8bd8"]])

export default __exports__